<template>
  <div id="roomList">
    <h3>{{ strings.choosearoom }}</h3>
    <p class="small" v-if="!noRegusRoom">{{ strings.choosearoom }} <strong>{{ numRoom }} {{ strings.outof }} {{numRoom}}</strong> {{ strings.rooms }} {{ strings.suitablecriteria }}.</p>

    <!-- Customized radio buttons -->
    <p class="loading-indicator" v-show="roomsReady == false && useNewVenuePage">
        <pulse-loader :color="'#9d9d9d'"></pulse-loader>
    </p>

    <form class="radio" v-if="!noRegusRoom && useNewVenuePage">
        
        <MPRoomAndPackageItem 
        :id="item.id" 
        v-for="(item, key) in roomList"
        :key="key"
        :title="item.title"
        :roomMin="item.min"
        :roomMax="item.max"
        :roomPriceVat="item.vat_price"
        :roomLayout="item.room_layout"
        :image="item.room_pictures"
        :instantBookable="item.instant_bookable"
        :correctPrice="item.correct_price"
        :chosenPriceType="item.chosen_price"
        :available="item.available"
        :exceed="item.exceed"
        :valid_layout="true"
        :isWebBookable="item.room_online"
        />

    </form>

    <form class="radio" v-if="!noRegusRoom && !useNewVenuePage">

        <RegusRoomItem 
        :id="item.id" 
        v-for="(item, key) in roomList"
        :key="key"
        :title="item.title"
        :roomMin="item.min"
        :roomMax="item.max"
        :roomPriceVat="item.vat_price"
        :roomLayout="item.room_layout"
        :image="item.room_pictures"
        />

    </form>

    <div class="temp mb-15 radio__no-avail" v-if="noRegusRoom">
        <label for="radio6">
            <div class="radio__main">
                <div class="radio__head radio__head-no-avail">
                    <h3>There is no room available. Please select another date/time, meeting length or delegates.</h3>
                </div>
            </div>
        </label>
    </div>

  </div>
</template>

<script>
import RegusRoomItem from './RegusRoomItem';
import MPRoomAndPackageItem from './RoomAndPackageItem';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
export default {
    data () {
        return {
            x: 5,
            step: 5,
            roomLeft: ''
        }
    },
    components: {
        RegusRoomItem,
        MPRoomAndPackageItem,
        PulseLoader
    },
    computed: {
        // If current tab is package, show room list in the chosen package. If not show all rooms.
        roomList() {
            if (this.useNewVenuePage)
                return this.$store.state.roomInfo;
            else 
                return this.$store.state.regusRoomInfo;          
        },
        numRoom() {
            return this.$store.state.regusRoomInfo.length;
        },
        strings () {
	        return this.$store.state.strings
        },
        noRegusRoom () {
            return this.$store.state.noRegusRoom
        },
        useNewVenuePage() {
            return this.$store.state.useNewVenuePage
        },
        roomsReady() {
            return this.$store.state.roomsReady;
        },
    },
    methods: {

    }
}
</script>

